import { useCallback } from "react"
import { EncryptionFn, useStage } from "./useStage"

export default function () {
  const encryptionFn: EncryptionFn<"credit-card-payment"> = useCallback(
    async (req, encrypt) => {
      // req.nonce = req.nonce ? await encrypt(req.nonce) : req.nonce
      // req.token = req.token ? await encrypt(req.token) : req.token
      if (req.creditCard && req.creditCard.cardNumber) {
        req.creditCard.nameOnCard = await encrypt(req.creditCard.nameOnCard)
        req.creditCard.cardNumber = await encrypt(req.creditCard.cardNumber)
        req.creditCard.cvv = await encrypt(req.creditCard.cvv)
        req.creditCard.expirationMonth = await encrypt(
          req.creditCard.expirationMonth
        )
        req.creditCard.expirationYear = await encrypt(
          req.creditCard.expirationYear
        )
        req.creditCard.postalCode = await encrypt(req.creditCard.postalCode)
      }
      return req
    },
    []
  )

  return useStage("credit-card-payment", encryptionFn);
}
